import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';

export const useRentTypeStore = create(
  devtools(
    combine(
      {
        rentType: 'BIKE' as string,
      },

      (set) => ({
        setRentType: (rentType: string) => {
          set({ rentType });
        },
      })
    )
  )
);
